import type { ReactNode } from 'react';
import { LinkContext } from './link-context';
import type { LinkComponent } from './types';

type LinkContextProviderProps = {
  Link: LinkComponent;
  children: ReactNode;
};

export function LinkContextProvider({ Link, children }: LinkContextProviderProps) {
  return <LinkContext.Provider value={{ Link }}>{children}</LinkContext.Provider>;
}
